import { FC, useMemo } from "react";

import {
  FilterByTextListAppliedFilterView,
  FilterByTextListItem,
} from "@/domain/view/components/datatable/datatable-filters/filter-by-text-list-applied-filter-view.tsx";

import { useGetUnitList } from "../../hooks/api/use-get-unit-list.ts";
import { UnitView } from "../unit-view.tsx";

import { DatatableUnitDisplayView } from "./datatable-unit-display-view.tsx";

export interface DatatableUnitAppliedFilterViewProps {
  workspace: {
    id: string;
  };
  column: {
    id: string;
  };
}

export const DatatableUnitAppliedFilterView: FC<DatatableUnitAppliedFilterViewProps> = ({ ...props }) => {
  const { unitList } = useGetUnitList({
    workspaceId: props.workspace.id,
  });

  const itemList = useMemo(() => {
    return unitList.map((unit) => ({
      id: unit.id,
      name: unit.title,
    }));
  }, [unitList]);

  const renderItem = (item: FilterByTextListItem | null, view: "icon" | "text" | "icon-text") => {
    const showLogo = false; // units do not have a unique item per user generated entry
    const showText = view === "text" || view === "icon-text";

    return (
      <UnitView
        key={item?.id}
        unit={item}
        className="h-3"
        placeholder={"Keine Einheit"}
        hideLogo={!showLogo}
        hideText={!showText}
      />
    );
  };

  const renderDisplayView = () => {
    return <DatatableUnitDisplayView />;
  };

  return (
    <FilterByTextListAppliedFilterView
      column={props.column}
      itemList={itemList}
      renderItem={renderItem}
      renderDisplayView={renderDisplayView}
    />
  );
};
